import { render, staticRenderFns } from "./CbsFormDesigner.vue?vue&type=template&id=50ddbecc&scoped=true"
import script from "./CbsFormDesigner.vue?vue&type=script&lang=js"
export * from "./CbsFormDesigner.vue?vue&type=script&lang=js"
import style0 from "./CbsFormDesigner.vue?vue&type=style&index=0&id=50ddbecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ddbecc",
  null
  
)

export default component.exports